import API from "./API";

export const userActivityAllAPI = (payload) => {
  return API.get(`/api/user-activity/all?page=${payload?.page || 0}&size=${payload?.size || 10}&sortBy=${payload?.sortBy || ''}&sortDir=${payload?.sortDir || ''}&vistedPage=${payload?.vistedPage || ''}&newUser=${payload?.newUser || ''}&jobApplied=${payload?.jobApplied || ''}&purchasedPlan=${payload?.purchasedPlan || ''}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const userActivityBySearchKeywordAPI = (payload) => {
  return API.get(`/api/user-activity/users/search/${payload?.keyword}?page=${payload?.page || 0}&size=${payload?.size || 10}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const userActivityBySearchLocationAPI = (payload) => {
  return API.get(`/api/user-activity/user/by-location/${payload?.location}?page=${payload?.page || 0}&size=${payload?.size || 10}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const userActivitySearchSummaryAPI = (payload) => {
  return API.get(`/api/user-activity/search/summary?page=${payload?.page || 0}&size=${payload?.size || 10}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const userActivityLocationSummaryAPI = (payload) => {
  return API.get(`/api/user-activity/location/summary?page=${payload?.page || 0}&size=${payload?.size || 10}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const userActivityJobCategoriesSummaryAPI = (payload) => {
  return API.get(`/api/user-activity/job-categories/summary?page=${payload?.page || 0}&size=${payload?.size || 10}`,)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};